module.exports = __webpack_public_path__ + "static/media/pk_12.bac4f8ce.png";